export const PLANT_EXPORT_ID = 'plant';

export const PLANT_TITLE = 'Planta';

export const LOCALIZED_PROPERTIES = {
  name: 'Nombre',
  company: 'Compañía',
  status: 'Estado',
};
